'use client';

import { useTranslations } from 'next-intl';

export function EventAwaitingBanner() {
  const t = useTranslations('event.awaitingResolution');

  return (
    <div className="mt-6 flex flex-col gap-4 rounded-[10px] bg-v2-surface-secondary px-8 py-6 shadow-v2-card">
      <span className="text-[15px] font-semibold leading-5 text-v2-text-primary">{t('title')}</span>
      <div className="flex flex-col">
        <span className="text-[13px] leading-5 text-v2-text-secondary">{t('description')}</span>
        <span className="text-[13px] leading-5 text-v2-text-secondary">{t('settlement')}</span>
      </div>
    </div>
  );
}
